export class Alerts {

    constructor() {
        this.initialize();
    }

    getError(field){

        if(this.alerts.errors[field]){

            return this.alerts.errors[field][0];

        }

    }

    getMessage(){

        if(this.alerts.message){

            return this.alerts.message;

        }else{

            return false;

        }

    }

    initialize(){

        this.alerts = {
            errors: [],
            message: '',
        }

    }

    recordErrors(errors){

        this.alerts.errors = errors;

    }

    recordMessage(message){

        this.alerts.message = message;

    }

    getErrors(){

        if(this.alerts.errors){

            return this.alerts.errors;

        }else{

            return false;

        }

    }

    isEmpty(){
        return Object.keys(this.alerts.errors).length === 0
    }


}
